export enum ToastClassEnum {
  warning = 'text-red',
  success = 'text-green-dark',
  default = 'text-gray-dark dark:text-gray-light'
}